module.exports = __webpack_public_path__ + "media/images/new_landing/case/case-henkel-block-3-166a1d16e4d60811726cf396dd90bb99.jpg";